/**
 * 矿场页面路径
 */
export const MINE_PAGE_PATH = '/mine'
